import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "🚀", key: "allIn" },
  { emoji: "🎯", key: "readyToTry" },
  { emoji: "👀", key: "wantToSeeFirst" },
]

export default function HomeCommitmentPage() {
  return <RadioCardListPage translationKey="homeCommitment" options={OPTIONS} />
}
